var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "276px",
    height: "137px",
    viewBox: "0 0 276 137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_Landing-page",
    transform: "translate(-168, -4231)",
    fill: "#040802",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(55, 3053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0, 1108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.313437,70 C187.918021,70 201.870833,75.2221354 212.171875,85.6664062 C222.472917,96.1106771 227.623437,111.545625 227.623437,131.97125 L227.623437,168.18875 C227.623437,183.735198 224.68862,196.365436 218.818984,206.079465 L196.132023,206.079622 C197.503613,204.921335 198.771064,203.638232 199.934375,202.230312 C206.495417,194.289687 209.775938,183.235833 209.775938,169.06875 L209.775938,130.960625 C209.775938,116.752292 206.410625,105.709896 199.68,97.8334375 C192.949375,89.9569792 183.160521,86.01875 170.313437,86.01875 C157.381563,86.01875 147.57151,89.9890625 140.883281,97.9296875 C134.195052,105.870312 130.850938,116.880625 130.850938,130.960625 L130.850938,169.06875 C130.850938,183.364167 134.152656,194.450104 140.756094,202.326562 C141.905114,203.697092 143.152504,204.948383 144.498265,206.080436 L121.823061,206.079465 C115.94102,196.365436 113,183.735198 113,168.18875 L113,131.97125 C113,111.545625 118.161406,96.1106771 128.484219,85.6664062 C138.807031,75.2221354 152.750104,70 170.313437,70 Z M362.499202,73.08 L362.499202,179.508438 L388.954202,179.508438 L388.954202,195.527187 L362.499202,195.527187 L362.499,206.079 L344.648,206.079 L344.648264,195.527187 L264.282952,195.527187 L264.282952,174.5275 L329.079827,73.08 L362.499202,73.08 Z M344.648264,83.935625 L341.623264,83.935625 L282.216389,176.923438 L282.216389,179.508438 L344.648264,179.508438 L344.648264,83.935625 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService4);
export default __webpack_public_path__ + "static/media/service4.8fd82c1778f9606fb7ab36602b242a7f.svg";
export { ForwardRef as ReactComponent };